import $ from 'jquery';
import { gsap } from "gsap";

/**
 * Mobile nav
 */
$(window).on('load', () => {
  const navToggle = $('#sd-nav .nav-toggle-container #nav-toggle');
  navToggle.on('click', () => {
    $('html').toggleClass('menu-active');
  });

  const navAside = $('#sd-nav aside');
  $(document).on('click', (e) => {
    if ($('html').hasClass('menu-active') && !$(e.target).closest(navToggle).length && !$(e.target).closest(navAside).length) {
      e.stopPropagation();
      e.preventDefault();
      $('html').removeClass('menu-active');
    }
  });
});

/**
 * Linking with hash to page element by scrolling
 */
// Detect if a link's href goes to the current page
const getSamePageAnchor = (link) => {
  if (
      link.protocol !== window.location.protocol ||
      link.host !== window.location.host ||
      link.pathname !== window.location.pathname ||
      link.search !== window.location.search
  ) {
    return false;
  }
  return link.hash;
}

// Scroll to a given hash, preventing the event given if there is one
const scrollToHash = (hash, e) => {
  const navHeight = document.querySelector('#sd-nav > .container').offsetHeight + 16 + 24;
  const elem = hash ? document.querySelector(hash) : false;

  if (elem) {
    const elemY = elem.getBoundingClientRect().top + window.scrollY - navHeight;

    if (e) {
      e.preventDefault();
    }
    window.scrollTo({
      behavior: 'smooth',
      top: elemY
    });
  }
  if (!elem && hash === '' && e) {
    e.preventDefault();
  }
}

// If a link's href is within the current page, scroll to it instead
document.querySelectorAll('a[href]').forEach((a) => {
  a.addEventListener('click', (e) => {
    scrollToHash(getSamePageAnchor(a), e);
  });
});

// Scroll to the element in the URL's hash on load
$(window).on('load', () => {
  scrollToHash(window.location.hash);
});
